export const fr: Record<string, string> = {
  // ── stat cards ──
  'dashboard.stat.resources': 'Ressources',
  'dashboard.stat.capabilities': 'Capacités',
  'dashboard.stat.outcomes': 'Résultats',
  'dashboard.stat.users': 'Utilisateurs',

  // ── setup section ──
  'dashboard.setup': 'Configuration',
  'dashboard.itemCount': '{n} éléments',
  'dashboard.manage': 'Gérer',
  'dashboard.downloadCsv': 'Télécharger le CSV',

  // ── upload modal titles ──
  'dashboard.uploadTitle.resources': 'Importer le CSV des ressources',
  'dashboard.uploadTitle.capabilities': 'Importer le CSV des capacités',
  'dashboard.uploadTitle.outcomes': 'Importer le CSV des résultats',

  // ── assessment phases ──
  'dashboard.assessmentPhases': 'Phases d’évaluation',
  'dashboard.phase.linking.title': '1. Association ressources–capacités',
  'dashboard.phase.linking.desc': 'Les utilisateurs associent les ressources pertinentes aux capacités',
  'dashboard.phase.linkQual.title': '2. Qualification des associations RC',
  'dashboard.phase.linkQual.desc': 'Qualifier les ressources associées (lecture seule pour les utilisateurs)',
  'dashboard.phase.linkQual.detail': 'L’administrateur qualifie les associations ressources–capacités',
  'dashboard.phase.scoring.title': '3. Notation de maturité et de pondération RC',
  'dashboard.phase.scoring.desc': 'Noter la criticité et la maturité des ressources qualifiées',
  'dashboard.phase.maturityQual.title': '4. Qualification pondération et maturité RC',
  'dashboard.phase.maturityQual.desc': 'Qualifier les ressources selon les notes de pondération et de maturité (lecture seule pour les utilisateurs)',
  'dashboard.phase.maturityQual.detail': 'L’administrateur qualifie les ressources notées',

  // ── phase details (dynamic) ──
  'dashboard.capabilitiesLinked': '{linked}/{total} capacités associées',
  'dashboard.ratingsCompleted': '{n} évaluations terminées',

  // ── phase status ──
  'dashboard.status.open': 'Ouvert',
  'dashboard.status.active': 'Actif',
  'dashboard.status.locked': 'Verrouillé',
};

export const en: Record<string, string> = {
  // ── stat cards ──
  'dashboard.stat.resources': 'Resources',
  'dashboard.stat.capabilities': 'Capabilities',
  'dashboard.stat.outcomes': 'Outcomes',
  'dashboard.stat.users': 'Users',

  // ── setup section ──
  'dashboard.setup': 'Setup',
  'dashboard.itemCount': '{n} items',
  'dashboard.manage': 'Manage',
  'dashboard.downloadCsv': 'Download CSV',

  // ── upload modal titles ──
  'dashboard.uploadTitle.resources': 'Upload Resources CSV',
  'dashboard.uploadTitle.capabilities': 'Upload Capabilities CSV',
  'dashboard.uploadTitle.outcomes': 'Upload Outcomes CSV',

  // ── assessment phases ──
  'dashboard.assessmentPhases': 'Assessment Phases',
  'dashboard.phase.linking.title': '1. Resource-Capability Linking',
  'dashboard.phase.linking.desc': 'Users link relevant resources to capabilities',
  'dashboard.phase.linkQual.title': '2. RC Link Qualification',
  'dashboard.phase.linkQual.desc': 'Qualify linked resources (read-only for users)',
  'dashboard.phase.linkQual.detail': 'Admin qualifies resource-capability links',
  'dashboard.phase.scoring.title': '3. RC Maturity and Weight Scoring',
  'dashboard.phase.scoring.desc': 'Score criticality and maturity of qualified resources',
  'dashboard.phase.maturityQual.title': '4. RC Weight & Maturity Qualification',
  'dashboard.phase.maturityQual.desc': 'Qualify resources based on weight and maturity scores (read-only for users)',
  'dashboard.phase.maturityQual.detail': 'Admin qualifies scored resources',

  // ── phase details (dynamic) ──
  'dashboard.capabilitiesLinked': '{linked}/{total} capabilities linked',
  'dashboard.ratingsCompleted': '{n} ratings completed',

  // ── phase status ──
  'dashboard.status.open': 'Open',
  'dashboard.status.active': 'Active',
  'dashboard.status.locked': 'Locked',
};
